import React from 'react';
import { Flex } from '@chakra-ui/react';

import './styles.scss';
import { EmptyStateGrayscaleImage } from '@assets/images';
import { TextBold, TextRegular } from '@components/typography';

const EmptyState = ({ text, description, emptyStateBottomComponent, image = <EmptyStateGrayscaleImage /> }) => (
    <Flex className="empty-state-global__container">
        {image}
        <TextBold className="empty-state__text">{text}</TextBold>
        <TextRegular className="empty-state__desc">{description}</TextRegular>
        {emptyStateBottomComponent}
    </Flex>
);

export default EmptyState;
